// libs
import { connect } from 'react-redux';

// components
import DesktopNotify from './DesktopNotify';

// selectors
import { getCustomerDisplayEmail } from 'shared/store/app/selectors';

const mapStateToProps = (state: any) => ({
  customerEmail: getCustomerDisplayEmail(state),
});

export default connect(mapStateToProps)(DesktopNotify);
